import { useMutation } from '@apollo/client'
import { triggerToast } from '@unbounded/unbounded-components'
import React, { useCallback, useEffect } from 'react'
import Layout from '~layout'
import ContactForm from './ContactForm'
import { contactQuery } from './ContactPage.gql'
import * as Styled from './ContactPage.styles'

const ContactPage: React.FC = () => {
  const [sendContact, { data, loading: isLoading, error, reset }] = useMutation(contactQuery)

  useEffect(() => {
    if (data && !error) {
      triggerToast('success', 'Message was sent successfully')
      reset()
    }
  }, [data, error, reset])

  const handleFormSubmit = useCallback(
    async (email: string, name: string, message: string) => {
      await sendContact({
        variables: {
          email,
          name,
          message,
        },
      })
    },
    [sendContact]
  )

  return (
    <Layout>
      <Layout.Content isCompact>
        <Styled.Container>
          <Styled.TextSection>
            <Styled.Title>We’d like to hear from you!</Styled.Title>
            <Styled.Paragraph>
              Looking to register your enterprise blockchain? Want to have it featured in a Project Spotlight? Just want to leave some general
              comments or suggestions regarding your Unbounded Network experience? Use the form to send us a short note and we’ll get back to you
              ASAP. In the meantime, stay in touch by registering for our newsletter or following us on Twitter.
            </Styled.Paragraph>
            {/* <Styled.Paragraph> */}
            {/*  Looking for careers? <Styled.Link href="https://hacera.bamboohr.com/jobs">View all job openings</Styled.Link> */}
            {/* </Styled.Paragraph> */}
          </Styled.TextSection>
          <Styled.Form>
            <ContactForm onSubmit={handleFormSubmit} isLoading={isLoading} isSuccess={Boolean(data)} error={error && 'Something went wrong'} />
          </Styled.Form>
        </Styled.Container>
      </Layout.Content>
    </Layout>
  )
}

export default ContactPage
